import { memberPresetInitialData } from "./InitialData"

export type MemberPresetsTableType = {
  memberPresetID: number
  members: number
  title: string
  presetMembers: []
}

const convertToMemberPresetReport = (data: memberPresetInitialData): MemberPresetsTableType[] => {

  const memberPresets = data?.presets ?? []

  const memberPresetData = memberPresets.map(memberPreset => ({
    memberPresetID: memberPreset.memberPresetID ?? 0,
    members: memberPreset.members ?? 0,
    title: memberPreset.title ?? '',
    presetMembers: memberPreset.presetMembers ?? [],
  }));

  return memberPresetData;
  
}

export const MemberPresetTableData = (data: memberPresetInitialData): MemberPresetsTableType[] => {
  return convertToMemberPresetReport(data)
}
